var _desc, _g, _g2, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldenStateLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390 98",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logo-title"
  }, "Golden State Garage Doors") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logo-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "logo-description"
  }, "California garage door company, license number 760866")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8bd25",
    d: "M20 2 62 3l.2 25.5 10.4 10.8 10.7 10.5 10.8 10.6 11.3 10.9-4.8 7.5-7.1 1.3-4.2 4-10.3-1.8-7.4-6.5-8.7-1.1-7.3-7.4-7.4-3.5-3.5-7.9-6.2-5.2-2.5-8.4-5.1-5.1-2.1-7.1-4.3-5.7 1.7-7.1-2.2-6.3 2.7-5.1-1.3-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f8bd25",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    d: "m35 48 5 1.5 3.8-2.2 4.3 2.5 3.7-.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 37,
    fill: "#fff",
    fontSize: 30,
    fontWeight: 800,
    letterSpacing: -0.7
  }, "Golden State"), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 68,
    fill: "#fff",
    fontSize: 30,
    fontWeight: 800,
    letterSpacing: -0.7
  }, "Garage Doors"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 87h55",
    stroke: "#f8bd25",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 188,
    y: 91,
    fill: "#d8d8d8",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12.5,
    fontWeight: 700,
    letterSpacing: 0.35
  }, "\n    LICENSE #760866\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenStateLogo);
export default __webpack_public_path__ + "static/media/golden-state-logo.06e42a7f0f5763921002d1c9fd061b7c.svg";
export { ForwardRef as ReactComponent };